// The whole file is copied from VPC
import { Colors } from '@tableau/icons/util/Colors';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { ListViewStyles } from '../ListViewStyles';
import { StyledCellFormatter } from '../StyledCellWrapper';

export interface ContentTypeCellOptions {
  imageUrlForRow: (row: DataGrid.Row) => (props: any) => React.ReactSVGElement;
  titleForIcon: (row: DataGrid.Row) => string;
  isCertified: (row: DataGrid.Row) => boolean;
}

export const ContentTypeCell = (options: ContentTypeCellOptions): React.StatelessComponent<BodyCell.Props> => {
  return StyledCellFormatter(
    React.createFactory(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      class ContentTypeCell extends React.Component<BodyCell.Props, any> {
        public render(): JSX.Element {
          const altText = options.titleForIcon(this.props.row);
          const icon = options.imageUrlForRow(this.props.row);

          return <div className={ListViewStyles.ContentTypeCellContainer}>{icon({ size: 18, color: Colors.Default, alt: altText })}</div>;
        }
      }
    )
  );
};
